'use strict';

var React = require('react');

var SvgLiveIcon = function SvgLiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.273 6.28c-2.05 2.05-2.05 5.375 0 7.425.293.293.293.768 0 1.06-.293.293-.768.293-1.06 0-2.637-2.635-2.637-6.91 0-9.545.292-.293.767-.293 1.06 0 .293.293.293.767 0 1.06Zm4.727 2.97c-.414 0-.75.336-.75.75s.336.75.75.75.75-.336.75-.75-.336-.75-.75-.75Zm-2.25.75c0-1.243 1.007-2.25 2.25-2.25s2.25 1.007 2.25 2.25-1.007 2.25-2.25 2.25-2.25-1.007-2.25-2.25Zm6.962 3.705c2.05-2.05 2.05-5.374 0-7.425-.293-.293-.293-.767 0-1.06.293-.293.768-.293 1.061 0 2.636 2.636 2.636 6.91 0 9.546-.293.293-.768.293-1.06 0-.293-.293-.293-.768 0-1.061Zm-7.421-5.657c-1.074 1.074-1.074 2.815 0 3.89.293.292.293.767 0 1.06-.293.293-.768.293-1.061 0-1.66-1.66-1.66-4.35 0-6.01.293-.293.768-.293 1.06 0 .294.292.294.767 0 1.06Zm5.403 3.89c1.074-1.075 1.074-2.816 0-3.89-.292-.293-.292-.768 0-1.06.293-.293.768-.293 1.061 0 1.66 1.66 1.66 4.35 0 6.01-.293.293-.768.293-1.06 0-.293-.293-.293-.768 0-1.06Z"
  }));
};
SvgLiveIcon.displayName = "LiveIcon";

exports.SvgLiveIcon = SvgLiveIcon;
